<template>
  <div>
    <h2 style="margin-bottom: 20px">报名录入</h2>
    <el-card>
      <el-form :model="form" :rules="rules" ref="form" label-width="100px" style="max-width: 600px">
        <el-divider content-position="left">学生信息</el-divider>
        <el-form-item label="学生姓名" prop="studentName">
          <el-input v-model="form.studentName" placeholder="请输入学生姓名" />
        </el-form-item>
        <el-form-item label="性别" prop="gender">
          <el-radio-group v-model="form.gender">
            <el-radio :label="1">男</el-radio>
            <el-radio :label="2">女</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="出生日期">
          <el-date-picker v-model="form.birthday" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" />
        </el-form-item>

        <el-divider content-position="left">家长信息</el-divider>
        <el-form-item label="家长姓名" prop="parentName">
          <el-input v-model="form.parentName" placeholder="请输入家长姓名" />
        </el-form-item>
        <el-form-item label="联系电话" prop="parentPhone">
          <el-input v-model="form.parentPhone" placeholder="请输入联系电话" />
        </el-form-item>
        <el-form-item label="关系">
          <el-radio-group v-model="form.relation">
            <el-radio label="父亲">父亲</el-radio>
            <el-radio label="母亲">母亲</el-radio>
            <el-radio label="祖父">祖父</el-radio>
            <el-radio label="祖母">祖母</el-radio>
            <el-radio label="监护人">监护人</el-radio>
            <el-radio label="其他">其他</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-divider content-position="left">课程信息</el-divider>
        <el-form-item label="课程类型">
          <el-select v-model="form.courseType" style="width:100%" @change="onCourseTypeChange">
            <el-option :value="1" label="大课（按课时打卡）" />
            <el-option :value="2" label="小课（按课时打卡）" />
            <el-option :value="3" label="年卡（记有效期；大课小课可打卡，不够记欠）" />
          </el-select>
          <div v-if="form.courseType === 3" class="exchange-hint" style="margin-left:0;margin-top:6px">
            年卡只记有效期。大课、小课都可打卡：够就扣，不够记欠。已有学员再报会续期。
          </div>
        </el-form-item>
        <el-form-item v-if="form.courseType === 2" label="带课教练">
          <el-select v-model="form.privateCoachId" filterable clearable placeholder="选填，上课教练登录即可划课" style="width:100%">
            <el-option v-for="c in coaches" :key="c.id" :label="c.name" :value="c.id" />
          </el-select>
          <div class="exchange-hint">
            没有可选教练？
            <el-button type="text" @click="$router.push('/coaches')">去开通教练账号</el-button>
          </div>
        </el-form-item>
        <el-form-item label="课程包">
          <el-input v-model="form.packageName" :placeholder="form.courseType === 3 ? '年卡' : '如：20课时标准包'" />
        </el-form-item>
        <el-form-item v-if="form.courseType !== 3" label="课时数" prop="hours">
          <el-input-number v-model="form.hours" :min="1" :max="999" />
        </el-form-item>
        <el-form-item v-if="form.courseType === 3" label="开始时间" required>
          <el-date-picker v-model="form.cardStart" type="date" value-format="yyyy-MM-dd" placeholder="年卡开始" style="width:100%" />
        </el-form-item>
        <el-form-item v-if="form.courseType === 3" label="结束时间" required>
          <el-date-picker v-model="form.cardEnd" type="date" value-format="yyyy-MM-dd" placeholder="年卡结束" style="width:100%" />
        </el-form-item>
        <el-form-item label="金额">
          <el-input-number v-model="form.amount" :min="0" :precision="2" />
        </el-form-item>
        <el-form-item label="凭证附件">
          <el-upload :show-file-list="false" :http-request="uploadAttach" accept="image/*,.pdf">
            <el-button size="mini">上传凭证</el-button>
          </el-upload>
          <div v-if="form.attachmentUrl" style="margin-top:8px">
            <el-link :href="form.attachmentUrl" target="_blank" type="primary">预览附件</el-link>
            <el-button type="text" @click="form.attachmentUrl=''">清除</el-button>
          </div>
        </el-form-item>
        <el-form-item v-if="form.courseType === 1" label="大课抵小课">
          <el-switch v-model="form.privateExchangeEnabled" active-text="开通" inactive-text="不开通" />
          <span class="exchange-hint">报名时设好比例，名单里可改。签到时教练选择划小课或抵扣；不够默认记欠。</span>
        </el-form-item>
        <el-form-item v-if="form.courseType === 1 && form.privateExchangeEnabled" label="兑换比例">
          <el-input-number v-model="form.privateExchangeRate" :min="2" :max="10" :step="1" />
          <span class="exchange-hint">节大课 = 1 节小课</span>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark" type="textarea" :rows="2" />
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="parentConsent">我确认已向家长说明上述信息用途，并已获得家长知情同意后再提交</el-checkbox>
          <div v-if="!parentConsent" class="consent-hint">提交前请勾选家长知情同意</div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="loading" :disabled="loading" @click="handleSubmit">提交报名</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { enroll, getPrivateExchangeSettings, uploadAdminFile, listAdminCoaches } from '../api'

function ymd(d) {
  const p = n => String(n).padStart(2, '0')
  return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate())
}
function defaultCardRange() {
  const start = new Date()
  const end = new Date()
  end.setFullYear(end.getFullYear() + 1)
  return { cardStart: ymd(start), cardEnd: ymd(end) }
}

export default {
  name: 'Enroll',
  data() {
    const range = defaultCardRange()
    return {
      loading: false,
      coaches: [],
      form: {
        studentName: '',
        gender: 1,
        birthday: '',
        parentName: '',
        parentPhone: '',
        relation: '父亲',
        courseType: 1,
        privateCoachId: null,
        packageName: '标准课程包',
        hours: 20,
        cardStart: range.cardStart,
        cardEnd: range.cardEnd,
        amount: 0,
        attachmentUrl: '',
        privateExchangeEnabled: false,
        privateExchangeRate: 2,
        remark: ''
      },
      parentConsent: false,
      rules: {
        studentName: [{ required: true, message: '请输入学生姓名', trigger: 'blur' }],
        parentName: [{ required: true, message: '请输入家长姓名', trigger: 'blur' }],
        parentPhone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { pattern: /^1\d{10}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        hours: [{
          validator: (rule, value, cb) => {
            if (this.form.courseType === 3) return cb()
            if (!value || value < 1) return cb(new Error('请输入课时数'))
            cb()
          },
          trigger: 'blur'
        }]
      }
    }
  },
  mounted() {
    this.loadDefaultRate()
    this.loadCoaches()
  },
  methods: {
    async loadCoaches() {
      try {
        const res = await listAdminCoaches({ page: 1, size: 50 })
        this.coaches = ((res.data && res.data.records) || []).filter(c => c.hasLoginAccount || c.adminUserId)
      } catch (e) {}
    },
    onCourseTypeChange(val) {
      if (val === 3) {
        this.form.packageName = '年卡'
        this.form.hours = 0
        this.form.privateExchangeEnabled = false
        const range = defaultCardRange()
        this.form.cardStart = range.cardStart
        this.form.cardEnd = range.cardEnd
        return
      }
      this.form.packageName = val === 2 ? '小课' : '标准课程包'
      if (!this.form.hours) this.form.hours = 20
      if (val !== 1) this.form.privateExchangeEnabled = false
    },
    async loadDefaultRate() {
      try {
        const res = await getPrivateExchangeSettings()
        const rate = (res.data && res.data.defaultRate) || 2
        if (rate >= 2) this.form.privateExchangeRate = rate
      } catch (e) {}
    },
    async uploadAttach({ file }) {
      const res = await uploadAdminFile(file)
      this.$set(this.form, 'attachmentUrl', res.data.url)
    },
    handleSubmit() {
      if (this.loading) return
      if (!this.parentConsent) {
        this.$message.warning('请勾选家长知情同意')
        return
      }
      this.$refs.form.validate(async valid => {
        if (!valid) return
        if (this.form.courseType === 3) {
          if (!this.form.cardStart || !this.form.cardEnd) {
            this.$message.warning('请选择年卡开始时间和结束时间')
            return
          }
          if (this.form.cardEnd < this.form.cardStart) {
            this.$message.warning('年卡结束日期不能早于开始日期')
            return
          }
        }
        this.loading = true
        try {
          const payload = { ...this.form, operator: localStorage.getItem('username') || 'admin' }
          if (payload.courseType !== 2) payload.privateCoachId = null
          if (payload.courseType === 3) payload.hours = 0
          const res = await enroll(payload)
          let hoursText = `大课剩余 ${res.data.remainingHours || 0} 课时`
          if (payload.courseType === 2) {
            hoursText = `小课剩余 ${res.data.privateRemainingHours || 0} 课时`
          } else if (payload.courseType === 3) {
            hoursText = `年卡 ${res.data.annualCardStart || payload.cardStart} 至 ${res.data.annualCardEnd || payload.cardEnd}`
          }
          const studentId = res.data && res.data.id
          const needFace = payload.courseType === 1 || payload.courseType === 3
          this.resetForm()
          if (needFace && studentId) {
            this.$confirm(
              `报名成功！学生：${res.data.name}，${hoursText}。是否现在录入人脸，便于拍照签到？`,
              '报名成功',
              { confirmButtonText: '去录入人脸', cancelButtonText: '稍后', type: 'success' }
            ).then(() => {
              this.$router.push({ path: '/students', query: { faceStudentId: String(studentId) } })
            }).catch(() => {})
          } else {
            this.$message.success(`报名成功！学生：${res.data.name}，${hoursText}`)
          }
        } finally {
          this.loading = false
        }
      })
    },
    resetForm() {
      this.$refs.form.resetFields()
      const range = defaultCardRange()
      this.parentConsent = false
      this.form.packageName = '标准课程包'
      this.form.hours = 20
      this.form.amount = 0
      this.form.attachmentUrl = ''
      this.form.relation = '父亲'
      this.form.courseType = 1
      this.form.privateCoachId = null
      this.form.privateExchangeEnabled = false
      this.form.privateExchangeRate = 2
      this.form.cardStart = range.cardStart
      this.form.cardEnd = range.cardEnd
    }
  }
}
</script>

<style scoped>
.exchange-hint { margin-left: 12px; color: #909399; font-size: 12px; }
.consent-hint { margin-top: 4px; color: #E6A23C; font-size: 12px; }
</style>
